import { Controller } from "@hotwired/stimulus"
import Player from "@vimeo/player"

// A Vimeo embed. Says when playback starts and stops, and when someone seeks, so the
// idle controller doesn't count someone watching a video, or scrubbing a paused one, as
// idle: they won't touch the mouse, and clicks inside the player's iframe never reach
// the page.
export default class extends Controller {
  connect() {
    this.player = new Player(this.element)
    this.player.on("play", () => this.dispatch("play"))
    this.player.on("pause", () => this.dispatch("stop"))
    this.player.on("ended", () => this.dispatch("stop"))
    this.player.on("seeked", () => this.dispatch("seek"))
  }

  // Not player.destroy(), which removes the iframe from the page Turbo is caching.
  disconnect() {
    for (const event of ["play", "pause", "ended", "seeked"]) this.player.off(event)
  }
}
